"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ua_parser_js_1 = require("ua-parser-js");
// singleton export since the user agent doesn't need to be re-instantiated during the lifecyle of the app
exports.default = new ua_parser_js_1.UAParser();
//# sourceMappingURL=user_agent_parser.js.map